export default {
  RECENT: 'recent',
  COOKIES_ACCEPTED: 'cookiesAccepted',
  PREVIOUS_SEARCH: 'previousSearch',
  FORM_OPENED: 'formOpened',
  SORT: 'sort',
  USER_PHONE: 'userPhone',
  USER_EMAIL: 'userEmail',
  JOURNEYS_RATING: 'journeysRating',
};
